import { createRouter, createWebHistory } from 'vue-router';
import Habitat from "@/pages/habitat/Habitat.vue";

const routes = [
    {
        path: '/habitat/',
        name: 'habitat',
        component: Habitat,
    },
]

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    linkExactActiveClass: "exactive",
    base: import.meta.env.BASE_URL,
    routes
})

export default router;
